"use strict";
/****************************************************
 * Audit Information Platform Component
 * 纯文本录入参照项目组件
 * 2020-08
 * Sunny <tufpsj@yonyou.com>
 ****************************************************/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
//----- Global ------
var React = require("react");
//----- iUAP ------
var tinper_bee_1 = require("tinper-bee");
//----- AIP -----
var RefItem_1 = require("./RefItem");
require("../style/RefItems.css");
/**
 * 文本类型的参照项是没有依赖参照的
 *
 */
var TextRef = /** @class */ (function (_super) {
    __extends(TextRef, _super);
    function TextRef() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            value: "",
            defaultValue: _this.props.defaultValue,
        };
        /**
         * 重置值 **override**
         * @function
         */
        _this.clear = function () {
            _this.setState({
                defaultValue: '',
                value: ''
            }, function () {
            });
        };
        /**
         * 值发生变化调用
         * @function
         * @param {string} value
         */
        _this._onChange = function (value) {
            _this.setState({
                value: value,
            }, function () {
                _this.refItemValueChange(value);
            });
        };
        /**
         * 获取数据的方法，会被调度系统触发 ** 每个子类必须实现 **
         * @function
         * @param {StringStringMap} params 依赖的参数对象
         * @param {string} defaultValue ***可选*** 默认值，如果有默认值，需要在`loadData`后设置设置关联值，再调用`refItemValueChange`通知调度器
         */
        _this.loadData = function (params, defaultValue) {
            if (defaultValue) {
                _this.setDefaultValue(defaultValue);
                _this.refItemValueChange(defaultValue);
            }
        };
        return _this;
    }
    TextRef.prototype.render = function () {
        return (React.createElement("div", { className: 'textref' },
            React.createElement(tinper_bee_1.FormControl, __assign({}, this.props, { defaultValue: this.state.defaultValue, showClose: true, value: this.state.value, onChange: this._onChange, style: { width: this.props.width || 200, height: 30 } }))));
    };
    return TextRef;
}(RefItem_1.default));
exports.default = TextRef;
